const pageId = '26023';

export default {
  pageName: 'Security Weekly Report',
  pageId,
  pagePath:
    '/opinion/CustomizedReports/WeeklyReport/Security-RelatedMentionsWeeklyReport',
  common: {
    source: 2,
    typeId: 'opinion_pc_v2',
  },
  button: {},
};
